// src/stores/useAnnotationToolStore.js
//
// State for the PadRekko "Annotations" command-rail tool. The rail button
// toggles the Arrow/Text menu; picking a type enters a self-contained draw mode
// (drawType) handled entirely by MapAnnotationTool — independent of the ruler.

import { create } from "zustand";

export const useAnnotationToolStore = create((set) => ({
  menuOpen: false,
  drawType: null, // 'text' | 'arrow' | null — active draw mode

  // Rail button: open the menu when idle; cancel everything when engaged.
  toggle: () =>
    set((s) => (s.menuOpen || s.drawType ? { menuOpen: false, drawType: null } : { menuOpen: true })),
  closeMenu: () => set({ menuOpen: false }),
  startDraw: (type) => set({ menuOpen: false, drawType: type }),
  stopDraw: () => set({ drawType: null }),
}));
